"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styleUtilities = require("@creditas-lab/style-utilities");

var _stylitas = require("@creditas/stylitas");

const Container = _stylitas.styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 16px 20px 12px 20px;

  ${_styleUtilities.media.md`
    padding: 32px 32px 32px 48px;
  `}
`;
exports.Container = Container;